export function getPaginatedReviews(productId, storeCode) {
    const endpoint = `/${storeCode}/V1/reviews/id/${productId}`;
    const options = {
        method: 'GET',
        cache: 'force-cache',
        next:{
            tags: ['reviews']
        }
    };

    return [endpoint, options];
}